import { createFileRoute, redirect } from "@tanstack/react-router";

/** Folded into the editor's Space panel. The old address keeps resolving. */
export const Route = createFileRoute("/console/spaces/$joinCode/settings")({
  beforeLoad: ({ params }) => {
    throw redirect({
      to: "/console/spaces/$joinCode/control",
      params: { joinCode: params.joinCode },
      search: { panel: "space" },
    });
  },
});
